// Adapt height to window resolution
function resizeContainer(){
  const footerh = $("#wrapper-footer").outerHeight();
  const headerh = $("#wrapper-navbar").outerHeight();
  $('.all-height').css({ minHeight: ($(window).outerHeight() - footerh - headerh )+ 'px' });
};
$(function() {
  $(window).resize(resizeContainer());
  resizeContainer();
});